export type FormStates = "default" | "saving" | "success" | "dirty";

export const CALENDAR_TIMES = {
  start: "07:00:00",
  end: "21:00:00",
};

export const START_TIME = 360; // 6:00 - default start_time if BE does not return end time for a service
export const END_TIME = 1320; // 22:00 - default end_time if BE does not return end time for a service
